import React, {useState} from 'react';
import { GMapForOverlayInput } from '../maps/gmapForOverlay';
import {
    List, Datagrid, TextField, ImageField, Edit, Filter, ReferenceInput,AutocompleteInput,
    TextInput, ImageInput, NumberInput, CloneButton, Pagination,
    EditButton, Create, TabbedForm, FormTab, DeleteButton, FormDataConsumer, Toolbar, useDelete, useRecordContext
} from 'react-admin';
import RangeInput from '../common/components/RangeInput';

const OverlayFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Site Name" source="track__site" perPage = {10000}
            sort={{ field: 'name', order: 'ASC' }}
            reference="sites">
            <AutocompleteInput optionText="name" />
        </ReferenceInput>
        {props.filterValues.track__site &&
            <ReferenceInput label="Course Name" perPage = {10000}
                sort={{ field: 'title', order: 'ASC' }}
                source="track" key={props.filterValues.track__site}
                reference="tracks" filter={{ site: props.filterValues.track__site }}>
                <AutocompleteInput optionText="title" />
            </ReferenceInput>
        }
    </Filter>
);

const OverlayPagination = props => <Pagination rowsPerPageOptions={[50, 25, 10]} {...props} />;

export const OverlayList = props => (
    <List {...props} title="Map Images List" filters={<OverlayFilter />} pagination={<OverlayPagination />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" />
            <ImageField source="image" />
            <TextField source="north_east.name" label={"North East Point"} />
            <TextField source="north_west.name" label={"North West Point"} />
            <TextField source="south_west.name" label={"South West Point"} />
            <TextField source="south_east.name" label={"South East Point"} />
            <EditButton />
            <DeleteButton mutationMode={"pessimistic"} />
            <CloneButton />
        </Datagrid>
    </List>
);

export const OverlayEdit = props => (
    <Edit title={<OverlayTitle />} {...props}>
        <TabbedForm name="overlayCreate" toolbar={<Toolbar alwaysEnableSaveButton={true}/>}>
            <FormTab label="General">
                <TextInput source="id" disabled/>
                <TextInput source="name" />
                <ImageField source="image" label="Current Image" title="Current Image" />
                <ImageInput source="image" label="Change Image" accept="image/*" placeholder={<p>Drag image or click here</p>}>
                    <ImageField source="src" />
                </ImageInput>
            </FormTab>
            <FormTab label="Coordinates">
            <div style={{display:"flex",flexDirection:"row",width:'100%',alignItems:"center",justifyContent:"center",height:"100%"}}>
                <div style={{display:"flex",flexDirection:"column",width:'100%',flex:1}}>
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.north_east.lat" label={"Lat of North East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.north_east.lng" label={"Lng of North East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.north_west.lat" label={"Lat of North West"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.north_west.lng" label={"Lng of North West"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_east.lat" label={"Lat of South East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_east.lng" label={"Lng of South East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_west.lat" label={"Lat of South West"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_west.lng" label={"Lng of South West"} />
                <RangeInput label="Overlay Opacity" source="opacity" step={0.1} min={0} max={1} />
                </div>
                <div style={{width:'100%',height:"100%",margin:10,flex:5}}>
                <FormDataConsumer>
                    {
                        ({ formData, ...rest }) =>
                            <GMapForOverlayInput
                                key="special"
                                source="coordinate"
                                searchable
                                formData={formData}
                                googleKey=""
                                {...rest}
                            />
                    }
                </FormDataConsumer>
                </div>
                </div>
            </FormTab>
        </TabbedForm>
    </Edit>
);

export const OverlayCreate = props => (
    <Create {...props}>      
        <TabbedForm redirect="list">
            <FormTab label="General">
                <TextInput source="name" />
                <ImageInput source="image" accept="image/*" placeholder={<p>Drag image or click here</p>}>
                    <ImageField source="src" />
                </ImageInput>
            </FormTab>
            <FormTab label="Coordinates">
                <div style={{display:"flex",flexDirection:"row",width:'100%',alignItems:"center",justifyContent:"center",height:"100%"}}>
                <div style={{display:"flex",flexDirection:"column",width:'100%',flex:1}}>
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.north_east.lat" label={"Lat of North East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.north_east.lng" label={"Lng of North East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.north_west.lat" label={"Lat of North West"} />
                <NumberInput style={{margin:5}}  step={"0.00001"} source="coordinate.north_west.lng" label={"Lng of North West"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_east.lat" label={"Lat of South East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_east.lng" label={"Lng of South East"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_west.lat" label={"Lat of South West"} />
                <NumberInput style={{margin:5}} step={"0.00001"} source="coordinate.south_west.lng" label={"Lng of South West"} />
                <RangeInput label="Overlay Opacity" source="opacity" step={0.1} min={0} max={1} />
                </div>
                <div style={{width:'100%',height:"100%",margin:10,flex:5}}>
                <FormDataConsumer>
                    {
                        ({ formData, ...rest }) =>
                            <GMapForOverlayInput
                                key="special"
                                source="coordinate"
                                searchable
                                formData={formData}
                                googleKey=""
                                {...rest}
                            />
                    }
                </FormDataConsumer>
                </div>
                </div>
            </FormTab>
        </TabbedForm>
    </Create>
);

const OverlayTitle = ({ record }) => {
    return <span>Map Image {record ? `"${record.name}"` : ''}</span>;
};